import equals from 'fast-deep-equal';
import { v4 } from '@leverege/base62-util';
import Utils from './Utils.js';
class ActionCache {
  static clearOnComplete = 'clearOnComplete';
  constructor(options = {}) {
    this.options = options;
    // by default only protect from concurrent repeat calls
    this.ttl = options && options.ttl || ActionCache.clearOnComplete;
    this.promises = {};
  }
  getOrSet(toCall, lookup) {
    const toReturn = this.get(lookup);
    if (toReturn) {
      return toReturn;
    }
    return this.set(toCall, lookup);
  }
  get(lookup) {
    const entries = Object.values(this.promises);
    for (let i = 0; i < entries.length; i++) {
      const value = entries[i];
      const {
        lookup: nLookup,
        time,
        id,
        ttl
      } = value || {};
      const compare = Utils.filterObjectFunctionProps(lookup);
      const nCompare = Utils.filterObjectFunctionProps(nLookup);
      if (equals(compare, nCompare)) {
        if (ttl === ActionCache.clearOnComplete || time + ttl > Date.now()) {
          return value.promise;
        }
        // lazy deletion
        delete this.promises[id];
      }
    }
    return null;
  }
  set(toCall, lookup, opts) {
    const id = v4();
    const ttl = (opts && opts.ttl) != null ? opts.ttl : this.ttl;
    const promise = new Promise(resolve => {
      setTimeout(() => {
        const promise = toCall();
        if (ttl === ActionCache.clearOnComplete) {
          this.awaitAndDelete(promise, id);
        }
        return resolve(promise);
      }, 0);
    });
    this.promises[id] = {
      lookup,
      promise,
      time: Date.now(),
      ttl,
      id
    };
    return promise;
  }
  delete(lookup) {
    const entries = Object.values(this.promises);
    for (let i = 0; i < entries.length; i++) {
      const value = entries[i];
      const {
        lookup: nLookup,
        id
      } = value || {};
      const compare = Utils.filterObjectFunctionProps(lookup);
      const nCompare = Utils.filterObjectFunctionProps(nLookup);
      if (equals(compare, nCompare)) {
        delete this.promises[id];
      }
    }
  }
  deleteById(id) {
    delete this.promises[id];
  }
  async awaitAndDelete(promise, id) {
    try {
      await promise;
    } catch (err) {
      // do nothing
    }
    this.deleteById(id);
  }
}
export default ActionCache;